export function exposeTrackingAPI(shellClient) {
    return {
        init: (withConsent) => shellClient.invokePluginMethod({
            plugin: 'tracking',
            method: 'init',
            args: [withConsent],
        }),
        onConsentModalDisplay: () => shellClient.invokePluginMethod({
            plugin: 'tracking',
            method: 'onConsentModal',
        }),
        onUserConsentFromModal: (consent) => shellClient.invokePluginMethod({
            plugin: 'tracking',
            method: 'onUserConsentFromModal',
            args: [consent],
        }),
        trackClick: (data) => shellClient.invokePluginMethod({
            plugin: 'tracking',
            method: 'trackClick',
            args: [data],
        }),
        trackPage: (data) => shellClient.invokePluginMethod({
            plugin: 'tracking',
            method: 'trackPage',
            args: [data],
        }),
        trackMixCommanderS3: (data) => shellClient.invokePluginMethod({
            plugin: 'tracking',
            method: 'trackMixCommanderS3',
            args: [data],
        }),
        trackEvent: (data) => shellClient.invokePluginMethod({
            plugin: 'tracking',
            method: 'trackEvent',
            args: [data],
        }),
        trackImpression: (data) => shellClient.invokePluginMethod({
            plugin: 'tracking',
            method: 'trackImpression',
            args: [data],
        }),
        trackClickImpression: (data) => shellClient.invokePluginMethod({
            plugin: 'tracking',
            method: 'trackClickImpression',
            args: [data],
        }),
        trackMVTest: (data) => shellClient.invokePluginMethod({
            plugin: 'tracking',
            method: 'trackMVTest',
            args: [data],
        }),
        setDefaults: (def) => shellClient.invokePluginMethod({
            plugin: 'tracking',
            method: 'setDefaults',
            args: [def],
        }),
        setRegion: (region) => shellClient.invokePluginMethod({
            plugin: 'tracking',
            method: 'setRegion',
            args: [region],
        }),
        setPciProjectMode: (params) => shellClient.invokePluginMethod({
            plugin: 'tracking',
            method: 'setPciProjectMode',
            args: [params],
        }),
        setConfig: (region, config) => shellClient.invokePluginMethod({
            plugin: 'tracking',
            method: 'setConfig',
            args: [region, config],
        }),
    };
}
//# sourceMappingURL=index.js.map